import { alpha, Box, Card, styled, ToggleButton } from '@mui/material';

export const QueryCard = styled(Card)(({ theme }) => ({
  borderRadius: '16px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  backgroundImage: 'none',
}));

export const ConditionBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.04),
}));

export const GroupBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isRoot',
})<{ isRoot: boolean }>(({ theme, isRoot }) =>
  isRoot ? {} : { borderLeft: `2px solid ${alpha(theme.palette.primary.main, 0.4)}` },
);

export const OperatorToggle = styled(ToggleButton)(({ theme }) => ({
  '&.Mui-selected': {
    color: theme.palette.accent.main,
    backgroundColor: alpha(theme.palette.accent.main, 0.16),
    '&:hover': { backgroundColor: alpha(theme.palette.accent.main, 0.24) },
  },
}));
